import { render, staticRenderFns } from "./ThePagePreloader.vue?vue&type=template&id=38c5e5ed&scoped=true&"
import script from "./ThePagePreloader.vue?vue&type=script&lang=js&"
export * from "./ThePagePreloader.vue?vue&type=script&lang=js&"
import style0 from "./ThePagePreloader.vue?vue&type=style&index=0&id=38c5e5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5e5ed",
  null
  
)

export default component.exports